import { Routes, Route, useLocation } from "react-router-dom"
import Home from '../../pages/Home'
import About from '../../pages/About'
import Blog from '../../pages/Blog'
import BlogPostPage from "../../pages/BlogPostPage"
import {AnimatePresence} from 'framer-motion'
import Team from "../../pages/Team"
import Login from "../../pages/auth/Login"
import Error404 from "../../pages/Error404"
import ForgotPassword from "../../pages/auth/ForgotPassword"
import Verification from "../../pages/auth/Verification"
import SignUp from "../../pages/auth/SignUp"
import ResetPassword from "../../pages/auth/ResetPassword"

function AnimatedRoutes() {
    const locator = useLocation()

  return (
    <AnimatePresence>
        <Routes location={locator} key={locator.pathname}>
            <Route path='/'>
            <Route index element={<Home/>}/>
            <Route path='home' element={<Home/>}/>
            <Route path='about' element={<About/>} />
            <Route path='blog' element={<Blog/>} />
            <Route path='blogpost/:id' element={<BlogPostPage/>} />
            <Route path='team' element={<Team/>}/>
            <Route path='login' element={<Login/>} />
            <Route path="signup" element={<SignUp/>} />
            <Route path="trynow" element={<SignUp/>} />
            <Route path='forgot_password' element={<ForgotPassword/>} />
            <Route path='reset_password' element={<ResetPassword/>} />
            <Route path='verify' element={<Verification/>} />
            <Route path='*' element={<Error404/>}/>
            </Route>
        </Routes>
    </AnimatePresence>
  )
}

export default AnimatedRoutes